import { textStyles, colors } from "../../../../theme/foundations/generated";
const ComponentStyle = {
    variants: {
        default: {
            root: {
                backgroundColor: "semantic.surface.1",
                border: "1px solid",
                borderColor: "semantic.border.secondary",
                borderRadius: "5rem",
                padding: "1",
            },
            tab: {
                display: "block",
                outline: "none",
                color: "semantic.text.primary",
                backgroundColor: "transparent",
                borderRadius: "5rem",
                p: textStyles.body.largeMedium,
                _hover: {
                    backgroundColor: "semantic.cta.secondaryHover",
                    _disabled: {
                        backgroundColor: "semantic.background.disabled",
                    },
                },
                _focusVisible: {
                    backgroundColor: "semantic.cta.secondaryHover",
                    outline: "0.1875rem solid",
                    outlineOffset: "0.125rem",
                    outlineColor: "semantic.outline.focus",
                    border: "none",
                    boxShadow: "none",
                },
                _selected: {
                    backgroundColor: "semantic.interactive.primary",
                    color: "semantic.text.inverse",
                },
                _disabled: {
                    opacity: 1,
                    color: "semantic.text.disabled",
                    backgroundColor: "semantic.background.disabled",
                },
            },
            tablist: {
                margin: 0,
                border: "none",
                gap: "2",
            },
        },
        medium: {
            root: {
                display: "flex",
                border: "none",
            },
            tab: {
                display: "block",
                outline: "none",
                color: "semantic.text.primary",
                backgroundColor: "semantic.surface.1",
                boxShadow: `inset 0 0 0 1px ${colors.semantic.border.secondary}`,
                padding: "auto 1rem",
                position: "relative",
                p: textStyles.body.largeMedium,
                _hover: {
                    boxShadow: "none",
                    backgroundColor: "semantic.cta.secondaryHover",
                    _after: {
                        borderTopColor: "semantic.cta.secondaryHover",
                    },
                    _disabled: {
                        backgroundColor: "semantic.background.disabled",
                    },
                },
                _focusVisible: {
                    backgroundColor: "semantic.cta.secondaryHover",
                    outline: "0.1875rem solid",
                    outlineOffset: "0.125rem",
                    outlineColor: "semantic.outline.focus",
                    boxShadow: "none",
                },
                _selected: {
                    backgroundColor: "semantic.interactive.primary",
                    color: "semantic.text.inverse",
                    boxShadow: "none",
                    _after: {
                        borderTopColor: "semantic.interactive.primary",
                    },
                },
                _disabled: {
                    opacity: 1,
                    color: "semantic.text.disabled",
                    backgroundColor: "semantic.background.disabled",
                    boxShadow: "none",
                },
            },
            tablist: {
                margin: 0,
                flexGrow: 1,
                gap: "1.5rem",
                border: "none",
            },
        },
        large: {
            root: {
                height: "3.75rem",
                backgroundColor: "semantic.surface.1",
                display: "flex",
                border: "none",
            },
            tab: {
                display: "block",
                outline: "none",
                color: "semantic.text.primary",
                backgroundColor: "semantic.background.info",
                padding: "auto 1rem",
                position: "relative",
                p: textStyles.subtitle.desktopMain,
                _after: {
                    content: '""',
                    width: 0,
                    height: 0,
                    borderLeft: "8px solid transparent",
                    borderRight: "8px solid transparent",
                    borderTop: "8px solid",
                    borderTopColor: "transparent",
                    position: "absolute",
                    bottom: "0",
                    transform: "translateY(100%)",
                    left: "calc(50% - 8px)",
                    transitionDuration: "normal",
                    transitionProperty: "common",
                },
                _hover: {
                    backgroundColor: "semantic.cta.secondaryHover",
                    _after: {
                        borderTopColor: "semantic.cta.secondaryHover",
                    },
                    _disabled: {
                        backgroundColor: "semantic.background.disabled",
                    },
                },
                _focusVisible: {
                    backgroundColor: "semantic.cta.secondaryHover",
                    outline: "0.1875rem solid",
                    outlineOffset: "0.125rem",
                    outlineColor: "semantic.outline.focus",
                    border: "none",
                    boxShadow: "none",
                },
                _selected: {
                    backgroundColor: "semantic.interactive.primary",
                    color: "semantic.text.inverse",
                    _after: {
                        borderTopColor: "semantic.interactive.primary",
                    },
                },
                _disabled: {
                    opacity: 1,
                    color: "semantic.text.disabled",
                    backgroundColor: "semantic.background.disabled",
                },
            },
            tablist: {
                margin: 0,
                flexGrow: 1,
                border: "none",
            },
        },
        xlarge: {
            root: {
                height: "4rem",
                backgroundColor: "semantic.surface.1",
                display: "flex",
                border: "none",
            },
            tab: {
                display: "flex",
                alignItems: "start",
                outline: "none",
                color: "semantic.text.primary",
                backgroundColor: "semantic.surface.1",
                borderBottom: "1px solid",
                borderColor: "semantic.border.secondary",
                padding: "4",
                p: textStyles.body.largeDemibold,
                _hover: {
                    backgroundColor: "semantic.cta.secondaryHover",
                    _disabled: {
                        backgroundColor: "semantic.background.disabled",
                    },
                },
                _focusVisible: {
                    backgroundColor: "semantic.cta.secondaryHover",
                    outline: "0.1875rem solid",
                    outlineOffset: "0.125rem",
                    outlineColor: "semantic.outline.focus",
                    boxShadow: "none",
                },
                _selected: {
                    backgroundColor: "transparent",
                    borderBottom: "4px solid",
                    borderColor: "semantic.interactive.primary",
                },
                _disabled: {
                    opacity: 1,
                    color: "semantic.text.disabled",
                    backgroundColor: "semantic.background.disabled",
                },
            },
            tablist: {
                margin: 0,
                flexGrow: 1,
                border: "none",
            },
        },
    },
    defaultProps: {
        variant: "default",
    },
};
export default ComponentStyle;
//# sourceMappingURL=Tabs.default.js.map